import { index, post, put } from "src/api/brand";
import BrandForm from "src/modules/brand/components/BrandForm.vue";

const getInitialState = () => {
  return {
    brands: [],
    brand: {},
  };
};

export const useBrandStore = defineStore("brand", () => {
  const formState = ref({
    edit: false,
    open: false,
  });

  const toggleBrandForm = (state = {}) => {
    state = { edit: false, open: !formState.value.open, ...state };

    const { toggleRightDrawer } = useAppStore();

    toggleRightDrawer(state.open, BrandForm);

    formState.value = state;
  };

  let state = reactive(getInitialState());

  const getBrand = (id) => {
    state.brand = state.brands?.find((brand) => brand._id === id);
  };

  const { filter, pagination, params } = usePagination();

  const getBrands = async (options = {}) => {
    try {
      const response = await index({
        params: unref(params),
        ...unref(options),
      });

      state.brands = response.data.data.data;

      pagination.value.rowsNumber = response.data.data.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postBrand = async (brand) => {
    try {
      const response = await post(brand);

      await getBrands();

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const putBrand = async (brand) => {
    try {
      const response = await put(brand);

      state.brand = response.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    formState,
    toggleBrandForm,

    filter,
    pagination,

    ...toRefs(state),

    getBrand,
    getBrands,
    postBrand,
    putBrand,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBrandStore, import.meta.hot));
}
